export const SAVE_ORDERFLOWADD = 'SAVE_ORDERFLOWADD'
export const SAVE_ORDERFLOWACTIVE = 'SAVE_ORDERFLOWACTIVE'
export const SHOW_HOUSE_INFO = 'SHOW_HOUSE_INFO'
export const SAVE_LIST_PAGE_PARS = 'SAVE_LIST_PAGE_PARS'



// WEBPACK FOOTER //
// ./src/story/mutation-types.js